// extracted by mini-css-extract-plugin
export default {"baseMoney":"alEg4","isFat":"Xz-xy","customCurrencyIcon":"_89xVT","skeleton-progress":"w3AGB"};